<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="custom-field-key-name">Nome</label>
          <InfoIcon size="1x" class="ml-2 info-icon" v-tooltip.right="{ content: nameInfo(), class: 'tooltip-in-modal'}" />
          <input id="custom-field-key-name" v-model="currentCustomField.name" class="form-control" :disabled="noEdit">
        </div>

        <div class="form-group">
          <label for="custom-field-key-description">Descrição</label>
          <textarea id="custom-field-key-description" v-model="currentCustomField.description" class="form-control"/>
        </div>

        <div class="form-group">
          <label for="custom-field-key-resource">Recurso</label>
          <select v-model="currentCustomField.resource" id="custom-field-key-resource" class="form-control" disabled="disabled">
            <option v-for="resource in resources" :key="resource.resource" :value="resource.resource"
              :title="resource.description">
              {{ resource.label }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="custom-field-key-kind">Tipo</label>
          <select v-model="currentCustomField.kind" id="custom-field-key-kind" class="form-control" :disabled="noEdit">
            <option value="input">Valor</option>
            <option value="select">Seleção</option>
          </select>
        </div>

        <div class="form-group" v-if="currentCustomField.kind === 'select'">
          <label for="custom-field-key-values">Valores</label>
          <textarea v-model="currentCustomField._values" id="custom-field-key-values" class="form-control"
            placeholder="Um valor por linha" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="$emit('cancel')">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import { InfoIcon } from 'vue-feather-icons'

const mapResources = {
  'Company': ['Empresa', 'Recurso disponivel apenas para empresas'],
  'Vehicle': ['Veículo', 'Recurso disponivel apenas para veículos'],
  'cm-embarcador/multa': ['Multa embarcador', 'Recurso disponivel apenas para multas de embarcador'],
  'cm-frotas/ticket': ['Multa frotas', 'Recurso disponivel apenas para multas de frotas'],
}

export default {
  components: { InfoIcon },
  computed: {
    disabledSaveButton() {
      if (this.currentCustomField.kind === 'select')
        return !(this.currentCustomField.name && this.currentCustomField.resource && this.currentCustomField._values)
      return !(this.currentCustomField.name && this.currentCustomField.resource)
    },
    resources() {
      return Object.entries(mapResources).map(([key, value]) => ({
        resource: key,
        label: value[0],
        description: value[1],
      }))
    },
    currentAxios() {
      return this.axios.v3
    },
    noEdit() {
      return this.customField.id
    }
  },
  created() {
    this.currentCustomField = this.customField
    this.currentCustomField.resource ||= 'cm-embarcador/multa'
    if (!this.currentCustomField.kind)
      this.$set(this.currentCustomField, 'kind', 'select')
    if (Array.isArray(this.currentCustomField.values))
      this.$set(this.currentCustomField, '_values', this.currentCustomField.values.join('\n'))
  },
  data: () => ({
    nameModel: 'CustomField',
    currentCustomField: {},
  }),
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    save() {
      const currentCustomField = this.currentCustomField.clone()
      if (this.currentCustomField.kind === 'select' && currentCustomField._values)
      currentCustomField.values = currentCustomField._values.split('\n')

      this.asyncTemplateSave(currentCustomField, {
        after: () => {
          this.$emit('savedCustomField')
          this.$emit('cancel')
        },
      })
    },
    nameInfo() {
      return 'O nome do campo personalizado deve ser com letra minúscula e sem espaços. Pode conter letras, números e hífen. Não pode começar com número'
    }
  },
  mixins: [ModelMapper],
  name: 'CustomFieldShow',
  props: {
    customField: { required: true, type: Object }
  },
}

</script>

<style scoped>
.info-icon {
  color: black;
}
</style>
